import * as React from "react";
import {StaticImage} from "gatsby-plugin-image";
import {Link} from "gatsby";

const navigation = {
    software: [
        {name: 'Maris PMS', href: '/software#pms'},
        {name: 'Maris HMS', href: '/software#hms'},
        {name: 'Maris HYD', href: '/software#hyd'},
        {name: 'Maris SDT', href: '/software#sdt'},
    ],
    services: [
        {name: 'Coastal Impact Studies', href: '/professional-services#cis'},
        {name: 'Wave Disturbance Studies', href: '/professional-services#wds'},
        {name: 'Metocean Studies', href: '/professional-services#ms'},
        {name: 'Water Renewal Studies', href: '/professional-services#wrs'},
    ],
    company: [
        {name: 'About', href: '/about-us'},
        {name: 'Pricing', href: '/pricing'},
        {name: 'Blog', href: '/blog'},
        {name: 'Contact', href: '/contact'},
    ],
}

export default function Footer() {
    return (
        <footer aria-labelledby="footer-heading" className="bg-[#C6D1E7]">
            <h2 id="footer-heading" className="sr-only">
                Footer
            </h2>
            <div
                className="px-32 py-20 flex flex-col lg:flex-row justify-between max-w-[90rem] mx-auto gap-y-4 lg:gap-y-0">

                <div className="flex flex-col space-y-8 text-center lg:text-left">
                    <StaticImage
                        height={80}
                        width={184}
                        objectFit="contain"
                        placeholder={"none"}
                        src="../images/scientia_logo.png"
                        alt="Company name"
                    />
                    <p className="text-sm leading-6 text-gray-600">
                        117 Agias Paraskevis Street
                        15234, Chalandri, Attica, Greece </p>
                    <p className="text-sm leading-6 text-gray-600">


                        +30 210 6848217
                        info@scientiamaris.com
                    </p>
                </div>
                <div className="gap-12 flex flex-col lg:flex-row  text-center lg:text-left">
                    <div className="mx-auto lg:ml-0">
                        <h3 className="text-sm font-semibold leading-6 text-gray-900">Software</h3>
                        <ul role="list" className="space-y-2">
                            {navigation.software.map((item) => (
                                <li key={item.name}>
                                    <Link to={item.href}
                                          className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="mx-auto lg:ml-0  text-center lg:text-left">
                        <h3 className="text-sm font-semibold leading-6 text-gray-900">Professional Services</h3>
                        <ul role="list" className="space-y-2">
                            {navigation.services.map((item) => (
                                <li key={item.name}>
                                    <Link to={item.href}
                                          className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="mx-auto lg:ml-0  text-center lg:text-left">
                        <h3 className="text-sm font-semibold leading-6 text-gray-900">Company</h3>
                        <ul role="list" className="space-y-2">
                            {navigation.company.map((item) => (
                                <li key={item.name}>
                                    <Link to={item.href}
                                          className="text-sm leading-6 text-gray-600 hover:text-gray-900">
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

            </div>
            <div className="bg-[#EEF2FF]">
                <div
                    className="flex flex-col lg:flex-row py-4 px-14 gap-y-4 lg:gap-y-0 items-center justify-between max-w-[90rem] mx-auto">
                    <div className="flex flex-row space-x-4 lg:order-last">
                        <a href="https://www.linkedin.com/company/scientiamaris/">
                            <svg height="32px" version="1.1" viewBox="0 0 60 60" width="32px"
                                 xmlns="http://www.w3.org/2000/svg"><title/>
                                <desc/>
                                <defs/>
                                <g fill="none" fill-rule="evenodd" id="Page-1" stroke="none" stroke-linejoin="round"
                                   stroke-width="1">
                                    <g id="Linkedin" stroke="#000000" stroke-width="2"
                                       transform="translate(1.000000, 1.000000)">
                                        <path
                                            d="M51,33.6902 L51,49.0002 L41.146,49.0002 L41.146,34.7492 C41.146,31.0202 39.606,28.4772 36.217,28.4772 C33.623,28.4772 32.179,30.1942 31.511,31.8462 C31.257,32.4442 31.298,33.2702 31.298,34.1002 L31.298,49.0002 L21.535,49.0002 C21.535,49.0002 21.662,23.7602 21.535,21.4652 L31.298,21.4652 L31.298,25.7872 C31.875,23.8972 34.996,21.2022 39.971,21.2022 C46.147,21.2022 51,25.1592 51,33.6902 L51,33.6902 Z"
                                            id="Stroke-18"/>
                                        <polygon id="Stroke-19" points="7.543 49 16.231 49 16.231 21.466 7.543 21.466"/>
                                        <path
                                            d="M16.7815,13.3799 C16.7815,15.7979 14.9335,17.7149 11.9735,17.7149 L11.9135,17.7149 C9.0595,17.7149 7.2115,15.8069 7.2115,13.3849 C7.2115,10.9159 9.1145,9.0499 12.0285,9.0499 C14.9335,9.0499 16.7215,10.9119 16.7815,13.3799 L16.7815,13.3799 Z"
                                            id="Stroke-20"/>
                                        <path
                                            d="M54,58 L4,58 C1.791,58 0,56.209 0,54 L0,4 C0,1.791 1.791,0 4,0 L54,0 C56.209,0 58,1.791 58,4 L58,54 C58,56.209 56.209,58 54,58 L54,58 Z"
                                            id="Stroke-103"/>
                                    </g>
                                </g>
                            </svg>
                        </a>


                    </div>
                    <StaticImage src={"../images/espa.png"} alt={"espa"} placeholder={"none"}
                                 className="max-h-8 w-56 object-contain"/>
                    <p className="text-xs leading-5 text-gray-500 lg:order-first">&copy; 2023 Scientia Maris. All rights
                        reserved.</p>


                </div>
            </div>
        </footer>
    )
}
